export default __webpack_public_path__ + "static/media/mongodb.5b90fb99.png";